import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import React from "react";

export default function MyDatePicker({ ...props }) {
  return <DatePicker {...props} format="DD/MM/YY" />;
}
